import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./NewAgentSearchPage.module.scss";
import { showErrorToast } from "../../../assets/toastUtils";
import { SvgRightIcon, SvgSearch } from "../../../utils/svgIcons";
import TransportHubsSearchInput from "../../NewSearchSateInput/TransportHubsSearchInput";
import NewMultiSelectSearch from "../../NewSearchSateInput/NewMultiSelectSearch";
import DatePicker from "react-datepicker";
import TransportHomepageHubsSearchInput from "../../NewSearchSateInput/TransportHomepageHubsSearchInput";
import { format } from "date-fns";

function NewUIAgentSearchFormTransport({
  topRadios,
  includingDestinations,
  setIncludingDestinations,
}) {
  const [guestDetails, setIsguestDetails] = useState(false);
  const [hub, setHub] = useState("");
  const [show, setShow] = useState(false);

  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  const [startDestination, setStartDestination] = useState("");
  const [endDestination, setEndDestination] = useState("");
  const [noOfDays, setNoOfDays] = useState("");

  const [selectedType, setSelectedType] = useState(null);
  // const [stateResultArray, setStateResultArray] = useState("");
  // console.log(stateResultArray);

  const getDataFromChild = (data, resultArray) => {
    setHub(data);
    // setSelectedType(selectedType);
    // setStateResultArray(resultArray)
  };

  const getDataFromChildForToCity = (data, resultArray, selectedType) => {
    setEndDestination(data);
    setSelectedType(selectedType);
    // setStateResultArray(resultArray)
  };
  // console.log(dataFromChild, "getDataFromChild");

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  const [checkin, setCheckin] = useState({
    day: checkinDay,
    month: checkinMonth,
    year: checkinYear,
  });

  const [checkout, setCheckout] = useState({
    day: checkoutDay,
    month: checkoutMonth,
    year: checkoutYear,
  });

  const navigate = useNavigate();

  // STATES
  const [date, setDate] = useState(new Date());
  const [selectedRadio, setSelectedRadio] = useState("");

  const [data, setData] = useState({
    fromCity: "",
    toCity: "",
  });

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  //
  const [adult, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);

  // Date alterations
  const [loader, setLoader] = useState(false);

  // const [checkin, setCheckin] = useState({
  //   day: router.query.checkinDay || "",
  //   month: router.query.checkinMonth || "",
  //   year: router.query.checkinYear || "",
  // });

  // const [checkout, setCheckout] = useState({
  //   day: router.query.checkoutDay || "",
  //   month: router.query.checkoutMonth || "",
  //   year: router.query.checkoutYear || "",
  // });

  useEffect(() => {
    if (
      checkinDay &&
      checkinMonth &&
      checkinYear &&
      checkoutDay &&
      checkoutMonth &&
      checkoutYear
    ) {
      const formatDateToString = (year, month, day) => {
        const paddedMonth = String(month).padStart(2, "0");
        const paddedDay = String(day).padStart(2, "0");
        return `${year}-${paddedMonth}-${paddedDay}`;
      };

      const checkInDateString = formatDateToString(
        checkinYear,
        checkinMonth,
        checkinDay
      );
      const checkOutDateString = formatDateToString(
        checkoutYear,
        checkoutMonth,
        checkoutDay
      );

      const checkInDate = new Date(checkInDateString);
      const checkOutDate = new Date(checkOutDateString);

      setStartDate(checkInDate);
      setEndDate(checkOutDate);
    }
  }, [
    checkinDay,
    checkinMonth,
    checkinYear,
    checkoutDay,
    checkoutMonth,
    checkoutYear,
  ]);

  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const onAdultIncrease = () => {
    const newAdult = adult + 1;
    setAdults(newAdult);
    if (newAdult > 1 && newAdult % 2 === 0 && rooms < newAdult / 2) {
      setRooms(rooms + 1);
    }
  };

  const onAdultDecrease = () => {
    if (adult > 1) {
      const newAdult = adult - 1;
      setAdults(newAdult);
      if (newAdult % 2 !== 0 && rooms > 1) {
        setRooms(rooms - 1);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const [selectedMultipleDestinations, setSelectedMultipleDestinations] =
    useState([]);

  const handleMultiDestinationsChange = (selected) => {
    setSelectedMultipleDestinations(selected);
    setIncludingDestinations(selected);
  };

  const handleSubmitButtonClickHandler = async (e) => {
    setIsguestDetails(false);
    setdestinationToggle(false);
    if (e) {
      e.preventDefault();
    }
    if (selectedMultipleDestinations.length === 0) {
      showErrorToast("Please select destinations!");
      return;
    }

    setLoader(true);

    try {
      await navigate(
        `/agent-search?startdestination=${hub}&noOfDays=${noOfDays}&date=${new Date(
          date
        ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
          date
        ).getFullYear()}&selectedDestination=${
          selectedMultipleDestinations?.length
        }`,
        {
          state: {
            includingDestinations: selectedMultipleDestinations,
          },
        },
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerTransport = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoader(true);

    try {
      await navigate(
        `/transport/${selectedType?.packagehandle}?packageId=${
          selectedType?.id
        }&startdestination=${hub}&noOfDays=${noOfDays}&date=${new Date(
          date
        ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
          date
        ).getFullYear()}`,
        {
          state: {
            includingDestinations: selectedMultipleDestinations,
          },
        },
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);
  return (
    <>
      <section
        onClick={() => setShow(false)}
        className={styles.NewUiSearchWrapper}
        id="home"
      >
        <div className={styles.NewUiSearchParent}>
          <div
            className=""
            style={
              guestDetails || destinationToggle
                ? { zIndex: "999" }
                : { position: "" }
            }
          >
            <form
              className={styles.NewUiSearchFormWrapper}
              onSubmit={
                selectedType?.type === "package"
                  ? handleSubmitButtonClickHandlerTransport
                  : handleSubmitButtonClickHandler
              }
            >
              <div className={styles.widthOfDestination}>
                <label htmlFor="">Starting From</label>
                <TransportHomepageHubsSearchInput
                  onClick={() => setdestinationToggle(true)}
                  onDataChange={getDataFromChild}
                  dropdownGuestDetails={dropdownGuestDetails}
                  setIsguestDetails={setIsguestDetails}
                />
              </div>
              <div className={styles.leftLineBorder}>
                <label htmlFor="">Including Destinations</label>
                <NewMultiSelectSearch
                  onClick={() => setdestinationToggle(true)}
                  onMultiSelectionChange={handleMultiDestinationsChange}
                  // selectedMultipleDestinations={selectedMultipleDestinations}
                  defaultSelected={selectedMultipleDestinations}
                  className={"search_form_input"}
                />
              </div>
              <div className={`${styles.widthOfNoOfDays}`}>
                <label htmlFor="">No. of Days</label>
                <input
                  type="number"
                  placeholder="1"
                  value={noOfDays}
                  onChange={(e) => setNoOfDays(e.target.value)}
                  style={{
                    border: "none",
                    outline: "none",
                    margin: "0",
                    width: "100%",
                  }}
                  required
                />
              </div>
              <div
                className={`${styles.leftLineBorder} new_date_picker_react_js_custom_styling`}
              >
                <label>Departure Date</label>
                {/* <Flatpickr
                    className="m_0 serach_form_input"
                    color="#ffffff"
                    value={date}
                    onChange={([date]) => setDate(date)}
                    min={new Date()}
                    // f
                    options={{
                      minDate: "today",
                    }}
                  /> */}

                <div className={styles.new_date_picker_wrapper}>
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                    dateFormat="dd MMM, yyyy"
                    placeholderText={
                      date ? format(date, "dd MMM, yyyy") : "Travel Date"
                    }
                  />
                </div>
              </div>
              <div className={styles.searchButtonDiv}>
                <button type="submit" className={styles.submitButton}>
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_6855_8179"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="16"
                        height="16"
                      >
                        <rect width="16" height="16" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6855_8179)">
                        <path
                          d="M13.0284 13.7178L8.8412 9.53051C8.50787 9.80574 8.12453 10.0211 7.6912 10.1767C7.25786 10.3322 6.80959 10.41 6.34636 10.41C5.20692 10.41 4.24259 10.0155 3.45336 9.22651C2.66414 8.43751 2.26953 7.4734 2.26953 6.33418C2.26953 5.19507 2.66403 4.23063 3.45303 3.44085C4.24203 2.65118 5.20614 2.25635 6.34536 2.25635C7.48448 2.25635 8.44892 2.65096 9.2387 3.44018C10.0284 4.2294 10.4232 5.19374 10.4232 6.33318C10.4232 6.80929 10.3433 7.26401 10.1835 7.69735C10.0236 8.13068 9.81036 8.50757 9.5437 8.82801L13.7309 13.0152L13.0284 13.7178ZM6.34636 9.41018C7.20536 9.41018 7.93292 9.11207 8.52903 8.51585C9.12525 7.91974 9.42336 7.19218 9.42336 6.33318C9.42336 5.47418 9.12525 4.74662 8.52903 4.15051C7.93292 3.55429 7.20536 3.25618 6.34636 3.25618C5.48736 3.25618 4.75981 3.55429 4.1637 4.15051C3.56748 4.74662 3.26936 5.47418 3.26936 6.33318C3.26936 7.19218 3.56748 7.91974 4.1637 8.51585C4.75981 9.11207 5.48736 9.41018 6.34636 9.41018Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </span>
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {(guestDetails || destinationToggle) && (
        <div
          onClick={() => [
            setIsguestDetails(false),
            setdestinationToggle(false),
          ]}
          className="ScreenDimmer"
        ></div>
      )}
    </>
  );
}

export default NewUIAgentSearchFormTransport;
